
<main class="content-container">
    <div class="home-page-sec">
        
        <section class="nodata-message-center">
            <div class="spinner"><i class="fa-solid fa-spinner fa-spin fa-4x"></i></div>
            <div class="fontsize">Please wait while you are redirected</div>
            <div class="fontsize-div">If you are not redirected within 30 seconds,</div>
            <div><span (click)="redirectToSurveyApp()" class="navigator-link">click here to go to the survey</span></div>
        </section>
        
    </div>
</main>